import decodeJwt from "helpers/jwt-token-access/jwtdecode";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectLoading, setLoading } from "slices/contract/reducer";
import { getContractorById, getContractsById, getHomeownerContractsById } from "slices/thunk";

const LiveContracts: React.FC = () => {
  const contracts = useSelector((state: any) => state.Contract.contracts);
  const dispatch: any  = useDispatch()
  const userType = decodeJwt()?.userType
  const navigation = useNavigate()
  const loading = useSelector(selectLoading)
useEffect(()=>{
dispatch(setLoading(true))
  const fetchData =  async()=>{
    if(userType !=="homeowner"){
      await dispatch(getContractsById());

    }else{
    await dispatch(getHomeownerContractsById());

    }

  }
  fetchData()
},[])
const liveContacts = contracts.filter((c:any) => c.p_status ==="LIVE")
  return (
    <React.Fragment>
    <div className="page-content contract-flow-page live-contracts-page tailwind-prefix">
      <Container fluid className="">
        {!loading ? (
  liveContacts.map((l: any) => (
    <div
      key={l.p_id}
      onClick={() => navigation(`/live-contract-details?id=${l.p_id}`)}
      className="p-4 mb-4 bg-gray-100 rounded-lg shadow-md border border-gray-300 cursor-pointer"
    >
      {/* Project Name */}
      <div
        className="text-lg font-semibold underline cursor-pointer hover:text-blue-700"
      >
        {l.p_name}
      </div>

      {/* Homeowner ID */}
      <div className="text-gray-600 text-sm mt-3">
        Homeowner ID: <span className="font-medium text-black">{l.p_home_owner_id}</span>
      </div>

      {/* Address */}
      <div className="text-gray-500 text-xs mt-1">
        {l.p_street_address}, {l.p_city}, {l.p_state} {l.p_zip}, {l.p_country}
      </div>

      {/* Budget */}
      <div className="text-xs text-gray-500 mt-3">
        ${l.p_cost} / ${l.p_total_cost} Budget
      </div>

      {/* Date Range */}
      <div className="text-xs text-gray-500 mt-1">
        {moment(l.p_created_at).format("MMM-DD, yyyy")}
      </div>

      {/* Blueprint Image */}
      {l.p_blue_print && (
        <div className="mt-3">
          <img
            src={l.p_blue_print}
            alt="Blueprint"
            className="w-full h-40 object-cover rounded-lg"
          />
        </div>
      )}

      {/* Button */}
      <button className="mt-3 px-4 py-2 border border-blue-600 text-black rounded-md bg-transparent cursor-pointer transition-colors hover:bg-blue-100">
        See Milestone Details
      </button>
    </div>
  ))
) : (
  // Lazy Loading Skeleton Effect
  <div className="grid gap-4">
    {[...Array(5)].map((_, i) => (
      <div key={i} className="p-4 mb-4 bg-gray-200 rounded-lg shadow-md animate-pulse">
        {/* Skeleton Title */}
        <div className="h-5 bg-gray-300 rounded w-3/4"></div>

        {/* Skeleton Text */}
        <div className="h-4 bg-gray-300 rounded w-1/2 mt-3"></div>
        <div className="h-4 bg-gray-300 rounded w-2/3 mt-2"></div>

        {/* Skeleton Budget */}
        <div className="h-4 bg-gray-300 rounded w-1/4 mt-3"></div>

        {/* Skeleton Date */}
        <div className="h-4 bg-gray-300 rounded w-1/3 mt-2"></div>

        {/* Skeleton Image */}
        <div className="w-full h-40 bg-gray-300 rounded mt-3"></div>

        {/* Skeleton Button */}
        <div className="h-8 bg-gray-300 rounded w-1/3 mt-3"></div>
      </div>
    ))}
  </div>
)}

      </Container>
    </div>
  </React.Fragment>
  );
};

export default LiveContracts;
